export default __webpack_public_path__ + "static/4-a0245041efa02504029e1f9f95766f81.png";